
import {  fetchEID , getLoggedInNumber, isMobileApp, isNativeApp, isNewIOSApp } from '@airtel-lego/native-app-bridge';

import { Keyboard } from 'react-native';
import { LOGIN_CONSTANTS } from '../constants/AppConstants';
import { getInteractionId, getStoreValuesAction } from './commonUtils';
import { convertTimestampToDate } from './otpUtils';


export const checkEsimCompatiblity = ({ additionalData, onUserAction, getState, args }: any) => {

    const actions: any[] = [];
    let isEsimCompatible = false;
 
 
    if (isNativeApp({}) && isNewIOSApp()) {
       isEsimCompatible = true
    }
 
    //Store generation date in redux through actions
    const esimData = {
       payload: {
          data: {
             isEsimCompatible
          },
          context: 'appData',
       },
       type: 'storeValuesInRedux',
    };
 
    actions.push(esimData);
    onUserAction({ actions });
 
 };
 
 export const validatePortNumberRevamp = ({ args, onUserAction, getState }: any) => {
    const { storeValues } = getState();
    const msisdn = storeValues?.appData?.msisdn;
    const portNumber = storeValues?.appData?.portingNumber;
    const pincode = storeValues?.pincodeContext?.pincodeDetails?.pincode;
    const lob = storeValues?.appData?.lob;
    const flow = storeValues?.appData?.flow;
    const portingWidgetId = storeValues?.portingWidgetId?.id;
 
    const actions: any[] = [];
 
    if (portNumber === msisdn) {
 
       actions?.push({
          payload: {
             eventData: {
                hintText: 'Porting number and alternate number cannot be the same.',
                state: 'error',
             },
             eventName: "portNumberInput",
          },
          type: 'nativeEventEmitter'
       });
 
 
    } else {
       actions?.push({
          "payload": {
             "authTokenGroup": "SKYC_REVERIFICATION",
             "requestType": "POST",
             "apiUrl": "guardian/api/buy/skyc/fetchmnpdetails/v1",
             "queryParams": {},
             "header": {},
             "body": {
                "pincode": "{{storeValues:appData.address.pincode}}",
                "siNumber": "{{storeValues:appData.portingNumber}}",
                "lob": "{{storeValues:appData.lob}}"
             }
          },
          "type": "apiCall"
       });
    }
 
    return onUserAction?.({
       actions,
    });
 };
 
 
 export const checkReduxData = ({ args, onUserAction, getState }: any) => {
    const { storeValues } = getState();
    const msisdn = storeValues?.appData?.msisdn;
    const actions: any[] = [];
 
    if (!msisdn) {
       actions.push({
          type: 'navigation',
          payload: {
             id: 'redirection',
             screenName: '/new-sim',
             params: {},
             type: 'replace',
          },
       });
    }
 
    return onUserAction?.({
       actions,
    });
 };
 
 
 export const checkVerificationReduxData = ({ args, onUserAction, getState }: any) => {
    const { storeValues } = getState();
    const msisdn = storeValues?.appData?.msisdn;
    const actions: any[] = [];
 
    if (!msisdn) {
       actions.push({
          type: 'navigation',
          payload: {
             id: 'redirection',
             screenName: '/verify',
             params: {},
             type: 'replace',
          },
       });
    }
 
    return onUserAction?.({
       actions,
    });
 };

 export const savedLoggedInSiNumberAndPrefillInput = async (onUserAction: any) => {
    const isApp = isMobileApp();
    const actions: any[] = [];
    try{
      if (isApp) {
         const number: any = await getLoggedInNumber();
         Keyboard.dismiss();
         actions.push({
            type: 'storeValuesInRedux',
            payload: {
               context: 'appData',
               data: {
                  loggedInNumber: number,
                  isUserLoggedIn: true,
               },
            },
         });
         actions.push({
            payload: {
               eventData: {
                  'carouselData[0]:formWidgetData:fields[0]:fieldData.value': number,
               },
               eventName: 'altNumberInputWidget',
            },
            type: 'nativeEventEmitter',
         });
      }
    }catch (err: any) {
      console.error(`Error while calling fetch EID: ${err}`);
   }
  
   return onUserAction?.({
      actions: actions,
   });
};
 
 export const handleAadhaarDetail = ({ args, onUserAction, getState }: any) => {
    const { storeValues } = getState();
    const documentId = storeValues?.appData?.kyc?.documentId;
    const actions: any[] = [];
    const documentType = documentId?.length === 12 ? 'A' : 'V';
    const isCheckBoxTick = storeValues?.appData?.isCheckBoxTick;
   
  
    actions.push( {
       "payload": {
          "data": {
             "kyc:documentType": documentType,
             "kyc:documentId": documentId,
          },
          "context": "appData"
       },
       "type": "storeValuesInRedux"
    });
 
    if(isCheckBoxTick){
       actions.push({
          "payload": {
             "eventData": {
                "buttonData.leftCta.disabled": false,
    
             },
             "eventName": 'VerifyAadhaar_Cta',
          },
          "type": 'nativeEventEmitter',
       });
    }else{
       actions.push({
          "payload": {
             "eventData": {
                "buttonData.leftCta.disabled": true,
    
             },
             "eventName": 'VerifyAadhaar_Cta',
          },
          "type": 'nativeEventEmitter',
       });
    }
   
    
    return onUserAction?.({
       actions,
    });
 };
  
 export const handleCheckBox = ({ args, onUserAction, getState }: any) => {
    const { storeValues } = getState();
    const actions: any[] = [];
    const documentId = storeValues?.appData?.kyc?.documentId;
  
    const checkBoxStatus = args?.[0]?.checkBoxStatus;
 
  
    if((documentId?.length == 12 || documentId?.length == 16) && checkBoxStatus){
       actions.push({
          "payload": {
             "eventData": {
                "buttonData.leftCta.disabled": false,
  
             },
             "eventName": 'VerifyAadhaar_Cta',
          },
          "type": 'nativeEventEmitter',
       });
    }else{
       actions.push({
          "payload": {
             "eventData": {
                "buttonData.leftCta.disabled": true,
             },
             "eventName": 'VerifyAadhaar_Cta',
          },
          "type": 'nativeEventEmitter',
       });
    }
  
    actions.push( {
       type: 'storeValuesInRedux',
       payload: {
          context: 'appData',
          data: {
             isCheckBoxTick: checkBoxStatus
        
          },
       },
    });
  
    return onUserAction?.({
       actions,
    });
 };
  
 
 export const handlefetchEID = async (onUserAction: any) => {
    const actions: any[] = [];
 
    try {
       const res: any = await fetchEID();
 
       if (isNewIOSApp()) {
          const obj1 = {
             type: 'nativeEventEmitter',
             payload: {
                eventName: 'EIDInputWidget',
                eventData: {
                   value: res,
                   disabled: true,
                },
                shouldResolveData: true,
             },
          };
 
          const obj2 = {
             type: 'storeValuesInRedux',
             payload: {
                context: 'appData',
                data: {
                   eid: res,
                },
             },
          };
 
          const obj3 = {
             type: 'nativeEventEmitter',
             payload: {
                eventName: 'confirmEIDCta',
                eventData: {
                   'buttonData.rightCta.disabled': false,
 
                },
                shouldResolveData: true,
             },
          };
 
          actions.push(obj1);
          actions.push(obj2);
          actions.push(obj3);
 
       }
    } catch (err: any) {
       console.error(`Error while calling fetch EID: ${err}`);
    }
 
    return onUserAction?.({
       actions: actions,
    });
 };
 
 
 export const checkPlanBackButton = ({ onUserAction, args, getState }: any) => {
    const { storeValues } = getState();
    const isPhysicalSimFlow = storeValues?.appData?.isPhysicalSimFlow;
    const isEsimFlow = storeValues?.appData?.isEsimSimFlow;
    const actions: any[] = [];
 
 
    if (isPhysicalSimFlow && !isEsimFlow) {
       //new / buy sim screen
       actions.push({
          "type": "navigation",
          "payload": {
             "screenName": "/select-connection",
             "type": "push",
             "shouldAddSearchParams": true,
             "params": {}
          }
       })
    } else {
       actions.push({
          "type": "navigation",
          "payload": {
             "screenName": "/choose-sim-type",
             "type": "push",
             "shouldAddSearchParams": true,
             "params": {}
          }
       })
    }
 
    return onUserAction({
       actions: actions,
    });
 };
 
 
 export const handleAddressChange = ({ onUserAction, args, getState }: any) => {
    const { storeValues } = getState();
    const lob=storeValues?.appData?.lob;
     const actions: any[] = [];
         const modalSection = lob?.toLowerCase() == "prepaid" ? "AddressModalSectionPrepaid" : "AddressModalSectionPostpaid"
         actions.push({
                 "payload": {
                         "modalData": {},
                         "modalSection": modalSection
                 },
                 "actionWithDelayed":500,
                 "type": "openModal"
         })
     
    return onUserAction({
       actions: actions,
    });
 };
 
 export const handleSendSMSPressRevamp = ({
    additionalData,
    onUserAction,
    getState,
 }: any) => {
    const { storeValues } = getState();
    const portingNumber = storeValues?.appData?.portingNumber;;
    const message = `PORT ${portingNumber}`;
    const smsUrl = `sms:1900?body=${encodeURIComponent(message)}`;
 
    // window.open(smsUrl, "_self");
 
    const actions: any[] = [];
    actions?.push(
       {
          type: 'navigation',
          payload: { externalUrl: smsUrl },
       },
    )
 
    return onUserAction?.({
       actions,
    });
 };
 
 export const hideKeyBoard = (props: any) => {
    Keyboard.dismiss();
 };

 //skyc-new bouncer send otp for prepaid
export const callBouncerOtp = ({ args, onUserAction, getState }: any) => {
    const { storeValues } = getState();
    const { milestone } = args;
    const msisdn = storeValues?.appData?.msisdn;
    const actions: any[] = [];
 
    let apiPayload={};
    let apiUrlSentOtp = 'guardian/api/skyc/sendOtp/v1';
    let apiUrlValidateOtp = 'guardian/api/skyc/validateOtp/v1';
 
    if(milestone=="init"){
 
       sessionStorage.removeItem(LOGIN_CONSTANTS.groupId)
 
 
     apiPayload = {
       "payload": {
          "authTokenGroup": LOGIN_CONSTANTS.groupId,
          "headers": {},
          "requestType": "POST",
          "apiUrl": "guardian/api/buy/skyc/track-order/v1",
          "queryParams": {
             "acquisitionType": "SKYC"
          },
          "body": {
             "pageName": "newAcq",
             "lob":"{{storeValues:appData.lob}}"
          },
          "loaderProps": {
             "show": true,
             "dismissAfterResponse": true
          }
       },
       "type": "apiCall"
    }
    }
    
 
    actions?.push({
       type: 'otpConsent',
       payload: {
          msisdn,
          groupId: LOGIN_CONSTANTS.groupId,
          otpDigitCount: 6,
          sessionStorageKey: LOGIN_CONSTANTS.groupId,
          modalProps: {
             width: 392,
             showCross: true,
             onClosePress: {
                actions: [
                   
                ],
             },
          },
          otpWidgetProps: {
             theme: "gen4",
             rtnOnChangeCta: true,
             title: 'Verify mobile number',
             subTitle: '6-digit OTP sent to',
             infoTextTop: 'Enter OTP',
             resendTimerCount: 30,
             numberOfInputs: 6,
             startCounter: true,
             loadingTitle: 'verifying your number',
             state: 'none',
             isValidating: false,
             style: {
                marginTop: -20
             },
             onChangeCtaPress: {
                id: 'onMsisdnChange',
                actions: [
                   {
                   type: 'closeModal',
                   },
                   {
                      "actionWithDelayed":700,
                      "payload": {
                        "modalData": {
                          "animationDuration": 220,
                          "showCross": true,
                          "showSubTitle": false,
                          "showHeaderTitle": false,
                          "isScrollView": false,
                          "closeOnPressMask": true,
                          "width": 392,
                          "disableContentPadding": true,
                          "minDistanceToCloseRatio": 0.2,
                          "swipeEnabled": false,
                          "maxWidth": 392,
                          "containerStyle": {
                            "padding": 0,
                            "backgroundColor": "#F5FBFB"
                          }
                        },
                        "modalSection": "AltNumberModalSection"
                      },
                      "type": "openModal"
                    }
                ],
             },
             id: 'artistOtpModal',
             primaryCtaProps: {
                buttonType: 'primary',
                style: {
             marginTop: 0,
             backgroundColor: "#000000",
             borderColor: "#000000",
             borderTopWidth: 1,
             borderTopColor: "#E6E9EF"
             },
                title: 'Confirm',
                size: 'lg',
                onPress: {
                   actions: [],
                },
             },
          secondaryCtaProps: {
             title: "Resend OTP",
             buttonType: 'tertiary',
             counterSuffix: 's',
             style: {
                marginTop: 16,
                marginBottom: 90,
                alignSelf: 'center',
             },
             version: 'fixed-padding',
             onPress: {
                actions: [],
             },
          },
          onInputFilled: {
             actions: [],
          },
          calloutWidgetProps: {
             description: "Your information stays safe with Airtel",
             iconName: "SecuredIcon",
             state: "success",
             isDark: false,
             showCrossDismissBtn: false,
             style: {
                marginTop: 16,
                marginBottom: 8,
                backgroundColor: "#E8F8EF",
                borderColor: "#E8F8EF"
             }
          }, },
          toastProps: {},
          onSendOtpSuccess: {
             actions: [
                {
                   payload: { args: [], utilName: 'storeBouncerSendOTP' },
                   type: 'callUtilFunction',
                }
             ],
          },
          onSendOtpFailure: {
             actions: [],
          },
          onVerifyOtpSuccess: {
             actions: [
                {
                   payload: { args: [], utilName: 'storeBouncerValidateOTP' },
                   type: 'callUtilFunction',
                },
                apiPayload
             ],
          },
          onVerifyOtpFailure: {
             actions: [
               
             ],
          }
       },
    });
   
    return onUserAction({
       actions
    });
 };

 export const checkDwebFlow = ({ additionalData, onUserAction, getState }: any) => {
    const actions: any[] = [];
    let isMobile = /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
       navigator.userAgent
    );
    const url = 'https://www.airtel.in/kyc/prepaid-sim?utm_layout=prepaid_sim';

    if (!isMobile) {
       // dweb flow

       actions?.push({
          type: 'navigation',
          payload: { externalUrl: url },
       });
    }
    return onUserAction?.({
       actions,
    });
 };

 export const prepareRevampDisabilityValidFormMetaData = ({
   additionalData,
   getState,
   uploadedSide,
}: any): any[] => {
   const { storeValues } = getState();
   const pwdData = storeValues?.pwdData ?? {};
   const widgetData = additionalData?.dataFromWidget ?? {};
   const disability = String(pwdData.disability ?? widgetData.disability ?? '')
      .trim()
      .toLowerCase();
   const dropdownValue = String(
      pwdData.dropdownValue ?? widgetData.dropdownValue ?? ''
   ).trim();
   const pwdPercent = String(
      pwdData.pwdPercent ??
         pwdData.disabilityPercent ??
         widgetData.pwdPercent ??
         widgetData.disabilityPercent ??
         ''
   ).trim();
   const isValidPercent = /^(?:[1-9]|[1-9][0-9]|100)$/.test(pwdPercent);
   // During upload success, the Redux flag may not
   // have been updated yet.
   const isFrontImageUploaded =
      pwdData.isFrontImageUploaded === true || uploadedSide === 'front';
   // No: disability details are not required.
   // Yes: type, percentage and front upload required.
   const isFormComplete =
      disability === 'no' ||
      (disability === 'yes' &&
         Boolean(dropdownValue) &&
         isValidPercent &&
         isFrontImageUploaded);

   return [
      getStoreValuesAction('pwdData', {
         isFormComplete,
      }),
   ];
};

export const handleRevampValidLocalReferenceMobileNumber = ({
   additionalData,
   onUserAction,
   getState,
}: any) => {
   const { storeValues } = getState();
   const msisdn =
      storeValues?.appData?.kyc?.refreeDetails?.mobileNumber 
   const activationCircle =
      storeValues?.appData?.address?.circleId
   const activationPincode =
      storeValues?.appData?.address?.pincode
   const lob = storeValues?.appData?.lob;
   const actions: any[] = [];

   // check local refree eligibility and disable cta
   actions?.push(
      {
         payload: {
            requestType: 'POST',
            apiUrl: 'guardian/api/buy/skyc/localRefreeEligibility/v1',
            authTokenGroup: LOGIN_CONSTANTS.groupId,
            header: {
               lob
            },
            body: {
               msisdn,
               activationPincode,
               activationCircle,
               lob
            },
         },
         type: 'apiCall',
      },
      {
         payload: {
            eventData: {
               'buttonData.leftCta.disabled': true,
            },
            eventName: 'LocalReference_VerifyOtpCta',
            shouldResolveData: true,
         },
         type: 'nativeEventEmitter',
      },
   );

   return onUserAction?.({
      actions,
   });
};
export const handleRevampValidateLocalReferenceForm = ({
   onUserAction,
   getState,
}: any) => {
   const { storeValues } = getState();
   const appData = storeValues?.appData || {};
   const refereeDetails = appData?.kyc?.refreeDetails || {};
   const isLocalReferee = refereeDetails?.outstation === false
   const {
      name = '',
      mobileNumber = '',
      houseNo = '',
      street = '',
      area = '',
      landmark = '',
      pinCode = '',
   } = refereeDetails;

   const isFormValid =
      name.trim().length > 0 &&
      /^[6-9]\d{9}$/.test(String(mobileNumber)) &&
      houseNo.trim().length > 0 &&
      street.trim().length > 0 &&
      area.trim().length > 0 &&
      /^[1-9][0-9]{5}$/.test(String(pinCode)) && 
      isLocalReferee


   const actions: any[] = [];

   if (isFormValid) {
      actions.push({
         type: 'apiCall',
         payload: {
            requestType: 'POST',
            apiUrl: 'guardian/api/buy/skyc/localRefreeEligibility/v1',
            authTokenGroup: LOGIN_CONSTANTS.groupId,
            header: {
               lob: appData?.lob,
            },
            body: {
               msisdn: mobileNumber,
               activationPincode: pinCode,
               activationCircle: appData?.address?.circleId,
               lob: appData?.lob,
            },
         },
      });
   } else {
      actions.push({
         type: 'nativeEventEmitter',
         payload: {
            eventName: 'LocalReference_VerifyOtpCta',
            eventData: {
               'buttonData.leftCta.disabled': true,
            },
            shouldResolveData: true,
         },
      });
   }

   return onUserAction?.({
      actions,
   });
};
     
export const handleRevampDisabilitySelection = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const disabilitySelection = args[0];
   const isYes = String(disabilitySelection).toLowerCase() === 'yes';
   const existingPwdData = storeValues?.pwdData || {};

   const actions: any[] = [
      {
         type: 'storeValuesInRedux',
         payload: {
            context: 'pwdData',
            data: {
               ...existingPwdData,
               disability: disabilitySelection,
                 ...(isYes?{}:{
               pwdPercent:"",
               videoRequired: false,
               isFrontImageUploaded:false,
               isBackImageUploaded:false,
               frontFileName:'',
               backFileName:''
            }),
         },
      },
      }
   ];

   return onUserAction?.({
      actions,
   });
};

export const handleDisabilityTypeSelect = ({
   additionalData,
   onUserAction,
   getState
}: any) => {
   const { storeValues } = getState();
   const item = additionalData?.item || additionalData?.dataFromWidget?.item || {};
   const dropdownValue = item?.value || item?.optionValue || additionalData?.data || '';
   const videoRequired = !!item?.videoRequired;
   const existingPwdData = storeValues?.pwdData || {};

   return onUserAction?.({
      actions: [
         {
            type: 'storeValuesInRedux',
            payload: {
               context: 'pwdData',
               data: {
                  ...existingPwdData,
                  dropdownValue,
                  videoRequired,
               },
            },
         },
      ],
   });
};

// submit & local referre sent otp
export const callRevampSendRefereeAndSubmitOtp = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const appData = storeValues?.appData || {};
   const isReferee = args?.[0]?.isReferee ?? appData?.isReferee ?? false;
   const kyc = appData?.kyc || {};
   const refereeDetails = kyc?.refreeDetails || {};
   const journey = appData?.journey;
   const lob = appData?.lob;
   const localMsisdn = refereeDetails?.mobileNumber;
   const msisdn = appData?.msisdn;
   const kycId = kyc?.kycId
   const circleId =
      appData?.address?.circleId || storeValues?.pincodeContext?.pincodeDetails?.circleId;
   const { layout } = storeValues?.journeyContext || {};
   const { planName } = appData?.planInfo || {};
   const customerName = kyc?.aadhaarDetails?.aadhaarName || refereeDetails?.name;
   const isOtpModalOpened = args?.[0]?.type === 'resend' ? true : false;
   const apiUrlSentOtp = 'guardian/api/buy/skyc/referee-and-submit/sendOtp/v1';
   const selectedMsisdn = appData?.newMsisdn
   if ((localMsisdn || msisdn) && localMsisdn === msisdn) {
      let actions: any = [
         {
            payload: {
               eventData: {
                  removeHintTextOnChange: true,
                  inputsDataProps: {
                     mobileNumber: {
                        hintText:
                           'This number & re-verification number cannot be same.',
                        state: 'error',
                     },
                  },
               },
               eventName: 'LOCAL_REFERENCE_DETAILS',
            },
            type: 'nativeEventEmitter',
         },
      ]

      return onUserAction({
         actions
      });
   }

   let actions = [
      {
         payload: {
            data: {
               isRefereeOtp: isReferee,
            },
            context: 'isReferee',
         },
         type: 'storeValuesInRedux',
      },
      {
         type: 'apiCall',
         payload: {
            requestType: 'POST',
            apiUrl: apiUrlSentOtp,
            authTokenGroup: LOGIN_CONSTANTS.groupId,
            body: {
               msisdn: isReferee ? localMsisdn : msisdn,
               customerName,
               isReferee,
               circleId,
               isResend: isOtpModalOpened,
               interactionId: kycId,
               coordinates: {
                  latitude: storeValues?.appData?.address?.latitude,
                  longitude: storeValues?.appData?.address?.longitude
               },
               lob,
               layout,
               contentPlaceholders: {
                  selectedMsisdn ,
                  planName,
                  customerName
               }
            },
            queryParams: {
               isOtpModalOpened,
            },
         },
      },
      {
         payload: {
            data: {
               isResendRefereeOtp: isReferee && isOtpModalOpened,
               isResendSubmitOtp: !isReferee && isOtpModalOpened,
            },
            context: 'resendOtpContext',
         },
         type: 'storeValuesInRedux',
      },
      {
         payload: {
            data: {
               otpGenerationTime: convertTimestampToDate(Date.now(), journey),
            },
            context: 'refreeAndSubmitOtp',
         },
         type: 'storeValuesInRedux',
      },
   ]
   return onUserAction({
      actions
   });
};

// submit & local referre verify otp
export const callRevampVerifyRefereeAndSubmitOtp = ({ data, onUserAction, getState }: any) => {
   const { storeValues } = getState();

   const appData = storeValues?.appData || {};
   const isReferee = storeValues?.isReferee?.isRefereeOtp;
   const kyc = appData?.kyc || {};
   const refereeDetails = kyc?.refreeDetails || {};
   const journey = appData?.journey;
   const lob = appData?.lob;
   const localMsisdn = refereeDetails?.mobileNumber;
   const msisdn = appData?.msisdn;
   const kycId = kyc?.kycId
   const circleId =
      appData?.address?.circleId || storeValues?.pincodeContext?.pincodeDetails?.circleId;
   const { layout } = storeValues?.journeyContext || {};
   const { planName } = appData?.planInfo || {};
   const customerName = kyc?.aadhaarDetails?.aadhaarName || refereeDetails?.name;
   const otp = storeValues?.refreeAndSubmitOtp?.otp;
   let apiUrlValidateOtp = 'guardian/api/buy/skyc/referee-and-submit/validateOtp/v1';
   const isResendRefereeOtp = storeValues?.resendOtpContext?.isResendRefereeOtp
   const isResendSubmitOtp = storeValues?.resendOtpContext?.isResendSubmitOtp
   const selectedMsisdn = appData?.newMsisdn
   const actions: any[] = [];

   actions?.push(
      {
         payload: {
            data: {
               otpValidationDateTime: convertTimestampToDate(Date.now(), journey),
            },
            context: 'refreeAndSubmitOtp',
         },
         type: 'storeValuesInRedux',
      }
   )

   actions?.push(
      {
         type: 'apiCall',
         payload: {
            requestType: 'POST',
            apiUrl: apiUrlValidateOtp,
            authTokenGroup: LOGIN_CONSTANTS.groupId,
            body: {
               msisdn: isReferee ? localMsisdn : msisdn,
               interactionId: kycId,
               otp,
               isReferee,
               circleId,
               isResend: isReferee ? isResendRefereeOtp : isResendSubmitOtp,
               coordinates: {
                 latitude: storeValues?.appData?.address?.latitude,
                  longitude: storeValues?.appData?.address?.longitude
               },
               lob,
               contentPlaceholders: {
                  selectedNumber:selectedMsisdn,
                  planName,
                  customer_name: customerName
               }
            }
         },
      }
   )

   return onUserAction({
      actions
   });
};

//skyc-new bouncer send otp for activation of sim card for prepaid
export const sendOtpSimActivationRevamp = ({ args, onUserAction, getState
}: any) => {
   const { storeValues
    } = getState();
   const msisdn = storeValues?.simActivationContext?.msisdn;
    const actions: any[] = [];


   const trackOrderPayload = {
        "payload": {
            "authTokenGroup": LOGIN_CONSTANTS.groupId,
            "headers": {},
            "requestType": "POST",
            "apiUrl": "guardian/api/buy/skyc/track-order/v1",
            "queryParams": {
                "acquisitionType": "SKYC",
            },
            "body": {
                "pageName": "simActivation"
            },
            "loaderProps": {
                "show": true,
                "dismissAfterResponse": true
            }
        },
        "type": "apiCall"
    }


    actions?.push({
       type: 'otpConsent',
       payload: {
          msisdn,
          groupId: LOGIN_CONSTANTS.groupId,
          otpDigitCount: 6,
          sessionStorageKey: LOGIN_CONSTANTS.groupId,
          modalProps: {
             width: 392,
             showCross: true,
             onClosePress: {
                actions: [],
                },
            },
          otpWidgetProps: {
             theme: "gen4",
             rtnOnChangeCta: true,
             title: 'Verify mobile number',
             subTitle: '6-digit OTP sent to',
             infoTextTop: 'Enter OTP',
             resendTimerCount: 30,
             numberOfInputs: 6,
             startCounter: true,
             loadingTitle: 'verifying your number',
             state: 'none',
             isValidating: false,
             style: {
                marginTop: -20
                },
             onChangeCtaPress: {
                id: 'onMsisdnChange',
                actions: [
                        {
                   type: 'closeModal',
                        },
                        {
                            "actionWithDelayed": 700,
                            "payload": {
                                "modalData": {
                                    "animationDuration": 220,
                                    "showCross": true,
                                    "showSubTitle": false,
                                    "showHeaderTitle": false,
                                    "isScrollView": false,
                                    "closeOnPressMask": true,
                                    "width": 392,
                                    "disableContentPadding": true,
                                    "minDistanceToCloseRatio": 0.2,
                                    "swipeEnabled": false,
                                    "maxWidth": 392,
                                    "containerStyle": {
                                        "padding": 0,
                                        "backgroundColor": "#F5FBFB"
                                    }
                                },
                                "modalSection": "AltNumberModalSection"
                            },
                            "type": "openModal"
                        }
                    ],
                },
             id: 'artistOtpModal',
             primaryCtaProps: {
                buttonType: 'primary',
                style: {
             marginTop: 0,
             backgroundColor: "#000000",
             borderColor: "#000000",
             borderTopWidth: 1,
             borderTopColor: "#E6E9EF"
                    },
                title: 'Confirm',
                size: 'lg',
                onPress: {
                   actions: [],
                    },
                },
          secondaryCtaProps: {
             title: "Resend OTP",
             buttonType: 'tertiary',
             counterSuffix: 's',
             style: {
                marginTop: 16,
                marginBottom: 90,
                alignSelf: 'center',
                    },
             version: 'fixed-padding',
             onPress: {
                actions: [],
                    },
                },
          onInputFilled: {
             actions: [],
                },
          calloutWidgetProps: {
             description: "Your information stays safe with Airtel",
             iconName: "SecuredIcon",
             state: "success",
             isDark: false,
             showCrossDismissBtn: false,
             style: {
                marginTop: 16,
                marginBottom: 8,
                backgroundColor: "#E8F8EF",
                borderColor: "#E8F8EF"
                    }
                },
            },
          toastProps: {},
          onSendOtpSuccess: {
             actions: [
                    {
                   payload: { args: [], utilName: 'storeBouncerSendOTP'
                        },
                   type: 'callUtilFunction',
                    }
                ],
            },
          onSendOtpFailure: {
             actions: [],
            },
          onVerifyOtpSuccess: {
             actions: [
                    {
                   payload: { args: [], utilName: 'storeBouncerValidateOTP'
                        },
                   type: 'callUtilFunction',
                    },
                trackOrderPayload
                ],
            },
          onVerifyOtpFailure: {
             actions: [],
            }
        },
    });



    return onUserAction({
       actions
    });
};